/**
 * Whether auth/session cookies should carry the `Secure` attribute.
 *
 * `Secure` cookies are only ever transmitted over HTTPS. Browsers that strictly
 * honor this (Safari, Firefox) will then refuse to SEND the cookie back over
 * plain `http://localhost` during local dev — so the server never sees the token
 * and silently bounces auth/guest flows (e.g. check-in → /welcome loops back to
 * check-in). Chromium special-cases `localhost` as a secure context, which
 * masked the problem in Chrome/Arc/Edge.
 *
 * Gate `secure` on the real protocol: Secure in production (served over HTTPS),
 * but plain over http://localhost so the cookie works in every browser locally.
 * SSR-safe — returns false when there is no `window`.
 */
export const secureCookie = (): boolean =>
  typeof window !== 'undefined' && window.location.protocol === 'https:';
